import { render, staticRenderFns } from "./CardLayout.vue?vue&type=template&id=6a0eff32&scoped=true&"
import script from "./CardLayout.vue?vue&type=script&lang=js&"
export * from "./CardLayout.vue?vue&type=script&lang=js&"
import style0 from "./CardLayout.vue?vue&type=style&index=0&id=6a0eff32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0eff32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
